import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "rightbar-container",
  relative: ""
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Signal = _resolveComponent("Signal")
  const _component_EditCompany = _resolveComponent("EditCompany")
  const _component_EditPerson = _resolveComponent("EditPerson")
  const _component_TrackCompany = _resolveComponent("TrackCompany")
  const _component_TrackPerson = _resolveComponent("TrackPerson")
  const _component_EditTopic = _resolveComponent("EditTopic")
  const _component_TrackTopic = _resolveComponent("TrackTopic")
  const _component_TrackCompanies = _resolveComponent("TrackCompanies")
  const _component_SmoothResize = _resolveComponent("SmoothResize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      class: "close-btn pointer",
      icon: "x",
      "stroke-width": "0.2",
      size: "2.4rem",
      onClick: $options.close
    }, null, 8 /* PROPS */, ["onClick"]),
    _createVNode(_component_SmoothResize, {
      class: "smoother",
      active: $props.view
    }, {
      signal: _withCtx(() => [
        (_openBlock(), _createBlock(_component_Signal, {
          key: $options.c_key,
          class: "rightbar-content",
          "predef-tab": $props.data.tab,
          "signal-id": $props.data.signal_id
        }, null, 8 /* PROPS */, ["predef-tab", "signal-id"]))
      ]),
      "edit-company": _withCtx(() => [
        (_openBlock(), _createBlock(_component_EditCompany, {
          key: $options.c_key,
          class: "rightbar-content",
          "company-id": $props.data.company_id,
          head: ""
        }, null, 8 /* PROPS */, ["company-id"]))
      ]),
      "edit-person": _withCtx(() => [
        (_openBlock(), _createBlock(_component_EditPerson, {
          key: $options.c_key,
          class: "rightbar-content",
          "contact-id": $props.data.contact_id,
          "company-id": $props.data.company_id,
          head: ""
        }, null, 8 /* PROPS */, ["contact-id", "company-id"]))
      ]),
      "track-company": _withCtx(() => [
        (_openBlock(), _createBlock(_component_TrackCompany, {
          key: $options.c_key,
          class: "rightbar-content",
          "linkedin-id": $props.data?.linkedin_id
        }, null, 8 /* PROPS */, ["linkedin-id"]))
      ]),
      "track-person": _withCtx(() => [
        (_openBlock(), _createBlock(_component_TrackPerson, {
          key: $options.c_key,
          class: "rightbar-content",
          "company-id": $props.data?.company_id
        }, null, 8 /* PROPS */, ["company-id"]))
      ]),
      "edit-topic": _withCtx(() => [
        (_openBlock(), _createBlock(_component_EditTopic, {
          key: $options.c_key,
          class: "rightbar-content",
          "topic-id": $props.data.topic_id,
          head: ""
        }, null, 8 /* PROPS */, ["topic-id"]))
      ]),
      "track-topic": _withCtx(() => [
        (_openBlock(), _createBlock(_component_TrackTopic, {
          key: $options.c_key,
          class: "rightbar-content"
        }))
      ]),
      "track-companies": _withCtx(() => [
        (_openBlock(), _createBlock(_component_TrackCompanies, {
          key: $options.c_key,
          class: "rightbar-content"
        }))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["active"])
  ]))
}